import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const ButtonCartDEL = ({
  modifiers,
  glyph,
  counter,
  linkUrl,
  linkText,
  onClick,
  onKeyDown,
  onMouseEnter,
  onMouseLeave,
  drawerKeyDown,
  drawerIsVisible,
  Drawer,
}) => {
  const drawerRef = useRef(null);
  const modifiersString = useIterateModifiers('del-button__', modifiers);
  const Tag = linkUrl ? 'a' : 'button';
  const { t } = useTranslation();

  useEffect(() => {
    if (drawerIsVisible) {
      drawerRef.current.focus();
      drawerRef.current.addEventListener('keydown', drawerKeyDown);
    } else if (drawerRef.current.getAttribute('listener')) {
      drawerRef.current.removeEventListener('keydown');
    }
  }, [drawerIsVisible]);

  return (
    <div
      onMouseEnter={onMouseEnter || null}
      onMouseLeave={onMouseLeave || null}
    >
      <Tag
        className={`del-button dln-outline ${modifiersString} ${
          drawerIsVisible ? 'displayNotificationDrawer' : ''
        }`}
        href={linkUrl || null}
        onClick={onClick || null}
        onKeyDown={onKeyDown || null}
        aria-label={t('cart:cart.page.title')}
      >
        <span className='del-btnIcon__wrap'>
          <i className={`del-icn del-icn__${glyph}`} />
          {counter >= 1 && (
            <span className='del-btnIcon__checkoutCounter'>
              <i className='del-btnIcon__checkoutCounterText'>{counter}</i>
            </span>
          )}
        </span>
        {linkText && <span className='dln-btnIcon__text'>{linkText}</span>}
      </Tag>
      <div ref={drawerRef} style={{ display: drawerIsVisible ? '' : 'none' }}>
        <Drawer />
      </div>
    </div>
  );
};

ButtonCartDEL.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
  glyph: PropTypes.string,
  counter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  drawerKeyDown: PropTypes.func,
  drawerIsVisible: PropTypes.bool,
  Drawer: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()]),
};

ButtonCartDEL.defaultProps = {
  modifiers: [],
  glyph: null,
  counter: null,
  linkUrl: null,
  linkText: null,
  onClick: null,
  onKeyDown: null,
  onMouseEnter: null,
  onMouseLeave: null,
  drawerKeyDown: null,
  drawerIsVisible: false,
  Drawer: null,
};

export default ButtonCartDEL;
